"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjectActionEventForDatalayerGa4 = exports.transformEventForDatalayerGa4 = void 0;
const types_1 = require("../../types");
const nullEvent = {
    event: null,
    eventAction: null,
    eventCategory: null,
    eventLabel: null,
    ecommerce: null,
};
function processRawEvent(event) {
    if (event === null) {
        return [];
    }
    else {
        return [nullEvent, event];
    }
}
function transformEventForDatalayerGa4(event, transformLegacyEventForDatalayerGa4) {
    if ('type' in event) {
        switch (event.type) {
            case 'test':
                return [];
            case 'legacy': {
                const transformed = transformLegacyEventForDatalayerGa4(event.data);
                return processRawEvent(transformed);
            }
            default: {
                const _exhaustive = event;
                return _exhaustive ? [] : [];
            }
        }
    }
    return processRawEvent(transformObjectActionEventForDatalayerGa4(event));
}
exports.transformEventForDatalayerGa4 = transformEventForDatalayerGa4;
function transformObjectActionEventForDatalayerGa4(event) {
    if (!(0, types_1.isBaseObjectActionEvent)(event)) {
        throw new Error('Invalid event');
    }
    const { object, action, properties } = event;
    return {
        properties,
        event: `${object} ${action}`,
    };
}
exports.transformObjectActionEventForDatalayerGa4 = transformObjectActionEventForDatalayerGa4;
//# sourceMappingURL=event-transformation.js.map